module.exports = __webpack_public_path__ + "img/logogallodark.4dc17758.svg";